export const INTERNAL_COMMENT_INPUT_WARNING =
  'Internal Comments can only be viewed by staff. ';
export const EXTERNAL_COMMENT_INPUT_WARNING =
  'Warning. External comments can be viewed by users. ';
export const COMMENT_INPUT_PLACEHOLDER_TEXT =
  'Write a comment here... Press enter to submit.';
